// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__di8Dd","yellow":"ErrorPage_yellow__F24b+"};